export { default } from './ScrollToTop.container'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Scroll/ScrollToTop/index.js